export default "__VITE_ASSET__DzvF7V4Z__"